import axios from 'axios';
import { AxiosResponse } from 'axios';


declare global {
    namespace wisenut {
        export interface SearchParam {
            /**
             * 검색어
             * @description 검색연산자
             * 스페이스(공백) : AND 조건
             * | : OR 조건 (ex. 검색|엔진)
             * ! : NOT 조건 (ex. 검색!엔진)
             * @example "검색 엔진", "검색|엔진", "검색!엔진"
             */
            query: string;
            /**
             * 정렬 방식
             * @description 정렬 방식은 'RANK/DESC', 'updatedDate/DESC', 'updatedDate/ASC' 중 하나를 선택할 수 있습니다.
             */
            sort: 'RANK/DESC' | 'updatedDate/DESC' | 'updatedDate/ASC';
            listCount?: number;
            startCount?: number;
        }

        export interface SearchResult {
            /**
             * 검색어
             */
            query: string;
            /**
             * 검색엔진 버전
             */
            version: string;
            collection: SearchResultItem<WisenutResponseItem>[];
        }

        export interface SearchResultItem<T> {
            status: 'success' | 'fail';
            collectionId: string;
            /**
             * @description 검색 결과의 총 개수
             */
            totalCount: number;
            /**
             * @description documentSet에 담긴 리턴된 검색 결과 수
             */
            resultCount: number;
            /**
             * @description 검색 결과 문서
             */
            documentSet: T[];
        }

        export interface WisenutResponseItem extends DocumentItem{
            DOCID: string;
            DATE: string;
            /**
             * 해당 문서의 컬렉션명 필드
             */
            alias: string;
            /**
             * 수집된 첨부파일의 내용이 작성되는 필드
             */
            attach: string;
        }

        export interface DocumentItem {
            indexId : string;
            articleId : number;
            title: string;
            tags: string;
            content: string;
            imageFilePath: string;
            isDraft: string;
            createdUser: string;
            createdUserName: string;
            createdUserNameEn: string;
            createdUserNameCh: string;
            createdUserNameJp: string;
            createdMailAddress: string;
            createdDept: string;
            createdDeptName: string;
            createdDeptNameEn: string;
            createdDeptNameCh: string;
            createdDeptNameJp: string;
            createdDate: string;
            updatedDate: string;
            fileCode: string;
            viewCount: number;
            boardId: number;
            comCode: string;
            boardName: string;
            boardNameEn: string;
            boardNameCh: string;
            boardNameJp: string;
            menuPath: string;
            articleStatus: string;
            fieldValues: string;
            attachFiles: string;
            fileServerPaths: string;
        }
    }
}

export class WisenutSearch {
    private serviceUrl: string = '';

    constructor(serviceHost: string | null = null) {
        let host = serviceHost || location.host;
        this.serviceUrl = `https://${host}/wisenut/search/board`;
    }

    search(param: wisenut.SearchParam, collectionId: string): Promise<Array<wisenut.SearchResultItem<wisenut.WisenutResponseItem>>> {
        try{
            return axios.post<wisenut.SearchResult>(this.serviceUrl, param)
                .then((res: AxiosResponse) => {
                    if(res.status != 200 || !res.data || !res.data.collection) {
                        throw new Error('Invalid response from Wisenut search service');
                    }

                    return res.data.collection;
                })
                .then((collection: wisenut.SearchResultItem<wisenut.WisenutResponseItem>[]) => {
                    if(collection.length === 0){
                        return [];
                    }

                    return collection.filter((col) => col.collectionId === collectionId);
                });
        }
        catch (error) {
            console.error('Error in WisenutSearch:', error);
            return Promise.reject(error);
        }
    }
}